module.exports = __webpack_public_path__ + "static/media/leftAlign.235a756d.svg";